/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  flex: {
    type: [String, Number]
  },
  lg: {
    type: [Number, Object]
  },
  md: {
    type: [Number, Object]
  },
  offset: {
    type: Number,
    "default": 0
  },
  order: {
    type: Number,
    "default": 0
  },
  pull: {
    type: Number,
    "default": 0
  },
  push: {
    type: Number,
    "default": 0
  },
  sm: {
    type: [Number, Object]
  },
  span: {
    type: Number,
    "default": 12
  },
  tag: {
    type: String,
    "default": "div"
  },
  xl: {
    type: [Number, Object]
  },
  xs: {
    type: [Number, Object]
  },
  xxl: {
    type: [Number, Object]
  }
};

export { props as default };
//# sourceMappingURL=col-props.mjs.map
